export default "__VITE_ASSET__7WCexXhf__"